import { Checkbox as Checkb, Form, CheckboxProps } from 'antd';
import { Checkbox } from '@mui/material'; 
import { boolean } from 'yup';

const CheckStan = (props: { width?: number, name: string, value?: any, label?: string, defauldVal?: any, offst?: number, CheCkDefauld?: boolean }) => {

    let Check = props.CheCkDefauld ?  true : false;
    return (
        <>
            <Form.Item valuePropName='checked' label={props.label} labelCol={{ span: props.width, offset: props.offst }} initialValue={Check} name={props.name} >
                <Checkbox  ></Checkbox>
            </Form.Item>
        </>
    )
}


export default CheckStan;